import { commonEnv } from 'src/environments/environment.common';
import { Environment } from '../types';

const env: Partial<Environment> = {
    production: false,
    environment: 'develop',
    googleMapApiKey: 'AIzaSyBVi3S7-vI4PLGwfsG5HS-746B96Dwuego',
    addressValidationApiKey: 'AIzaSyAjIsg47VqFZkXMzWwVAWMXR63m9k14g3c',
    projects: {
        sprintPay: 'https://qa.sprintpay.cargosprint.com',
    },
    authenticationURL: 'https://auth-develop.cargosprintgroup.com',
    appSentryDsn: 'https://4c25b53b4f22ef6e57a4a0fb0df84a0c@o4507493303582720.ingest.us.sentry.io/4507931300331520',
    statsigSdkKey: 'client-TMqqFjGeGc0kG9eRXJ6v4lOagxLOSuBdNvCfH6RjsO1',
    keycloakConfig: {
        url: 'https://sso-qa.cargosprint.com',
        realm: 'unified-portal-new',
        clientId: 'test-ui',
    },
    applicationName: 'dsv',
};

export const environment = Object.assign(commonEnv, env);
